module.exports = __webpack_public_path__ + "img/computer.9029cc34.png";